// Route guard for the /admin/* subtree. We don't have the user's roles
// reliably in client state, so we use the simplest possible signal:
// ping a cheap admin endpoint. 200 → render. 401 / 403 → redirect to
// /login-sign-up with a redirectTo back here so post-login the user
// lands on /admin again.

import React, { useEffect, useState } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getOverview } from './adminApi';

export default function AdminRoute({ path, component: Component }) {
    const [status, setStatus] = useState('checking'); // 'checking' | 'ok' | 'denied'

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                await getOverview();
                if (!cancelled) setStatus('ok');
            } catch (e) {
                if (!cancelled) setStatus('denied');
            }
        })();
        return () => { cancelled = true; };
    }, []);

    return (
        <Route path={path} render={(props) => {
            if (status === 'checking') {
                return <div style={{ padding: 32, color: '#888' }}>Checking access…</div>;
            }
            if (status === 'denied') {
                return <Redirect to="/login-sign-up?redirectTo=/admin" />;
            }
            return <Component {...props} />;
        }} />
    );
}
